import React, { useState } from "react";
import { Row, Col } from "antd";
import { IonLabel } from "@ionic/react";

import { useTranslation } from "react-i18next";

const Country = ({ country, onUpdate, ...props }) => {
  const { t, i18n } = useTranslation();

  return (
    <Row align="middle" {...props}>
      <Col span={6}>
        <IonLabel style={{ fontSize: "1rem" }}>{t("newVendor.country")}&nbsp;</IonLabel>
      </Col>
      <Col span={18}>Canada</Col>
    </Row>
  );
};

export default Country;
